import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_EVENTS_REQUEST = "FETCH_EVENTS_REQUEST";
export const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_ERROR = "FETCH_EVENTS_ERROR";

export const readEvents = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchEventsRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/audit', {filters}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchEventsSuccess, fetchEventsError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchEventsError));
        }
    };
};

const fetchEventsRequest = () => {
    return {
        type: FETCH_EVENTS_REQUEST
    };
};

const fetchEventsSuccess = (payload) => {
    return {
        type: FETCH_EVENTS_SUCCESS,
        payload
    };
};

const fetchEventsError = (errorMessage) => {
    return {
        type: FETCH_EVENTS_ERROR,
        errorMessage
    };
};